<template>
    <div>
        <div v-if="showPersonalCicumstances" class="alert alert-vulnerable" role="alert">
            {{personalCircumstancesMessage}}
        </div>
        <div v-if="showPolFedSuffolk" class="alert alert-fred" role="alert">
            {{polFedSuffolkMessage}}
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            selectedClaim: {
                type: Object,
                required: true
            }
        },
        computed: {
            showPersonalCicumstances() {
                return this.selectedClaim.claimantDetails.personalCircumstances
            },
            personalCircumstancesMessage() {
                return 'The customer has indicated that they may require additional support due to personal circumstances!'
            },
            showPolFedSuffolk() {
                if (this.selectedClaim.resellerId == 999) {
                    if (this.selectedClaim.policyDetails.deserialisedObject.federationId == 35) {
                        return true
                    }
                }
                return false
            },
            polFedSuffolkMessage() {
                return 'This federation has been removed from the scheme.  The incident date must be no later than 31st January 2025.'
            }
        }
    }
</script>
<style>
    .alert-vulnerable {
        background-color: #FF148B;
        color: white;
        border-color: #FF148B;
    }
    .alert-fred {
        background-color: #ff9933;
        color: white;
        border-color: #ff9933;
    }
</style>